import {
  Injectable,
  inject
} from '@angular/core';

import {
  Observable,
  Subject
} from 'rxjs';

// ======================================================
// SERVICES
// ======================================================

import { HttpService } from '../http/http.service';

// ======================================================
// API ENDPOINTS
// ======================================================

import {
  GET_USER_PROFILE_URL,
  MANAGE_2FA_URL,
  PROFILE_IMAGE_URL,
  PUT_USER_PROFILE_URL,
  RESET_PASSWORD_WITHOUT_OTP_URL
} from '../constants/apiEndpoints.constants';

// ======================================================
// TYPES
// ======================================================

interface ProfilePicturePayload {
  authToken: string;
  pictureUrl: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  // ======================================================
  // DI
  // ======================================================

  private readonly apiSrv =
    inject(HttpService);

  // ======================================================
  // EVENTS
  // ======================================================

  readonly onDPChange =
    new Subject<string>();

  readonly onUserDetailsChange =
    new Subject<any>();

  // ======================================================
  // GET PROFILE
  // ======================================================

  getUserProfile():
    Observable<any> {

    return this.apiSrv.get(
      GET_USER_PROFILE_URL
    );
  }

  // ======================================================
  // UPDATE PROFILE
  // ======================================================

  putUserProfile(
    payload: unknown
  ): Observable<any> {

    return this.apiSrv.put(
      PUT_USER_PROFILE_URL,
      payload
    );
  }

  // ======================================================
  // UPLOAD PROFILE IMAGE
  // ======================================================

  postProfileImage(
    payload: FormData
  ): Observable<any> {

    return this.apiSrv.post(
      PROFILE_IMAGE_URL,
      payload
    );
  }

  // ======================================================
  // DELETE PROFILE IMAGE
  // ======================================================

  deleteProfileImage():
    Observable<any> {

    return this.apiSrv.delete(
      PROFILE_IMAGE_URL
    );
  }

  // ======================================================
  // MANAGE 2FA
  // ======================================================

  manage2FA(
    payload: unknown
  ): Observable<any> {

    return this.apiSrv.post(
      MANAGE_2FA_URL,
      payload
    );
  }

  // ======================================================
  // GET PROFILE PICTURE
  // ======================================================

  getProfilePicture(
    payload: ProfilePicturePayload
  ): Observable<Blob> {

    const {
      authToken,
      pictureUrl
    } = payload;

    return this.apiSrv.getBlob(
      pictureUrl,
      {
        authToken
      },
      {
        loadInBackground: true
      }
    );
  }

  // ======================================================
  // RESET PASSWORD
  // ======================================================

  resetPassword(
    payload: unknown
  ): Observable<any> {

    return this.apiSrv.post(
      RESET_PASSWORD_WITHOUT_OTP_URL,
      payload
    );
  }
}